import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepThreeLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepThreeLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.memoryStepThreeLevels.data.memoryStepThreeLevelsRandom,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
